var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClockStroke = function SvgIconClockStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M12 1c6.074 0 11 4.926 11 11s-4.926 11-11 11S1 18.074 1 12 5.926 1 12 1m0 1.7c-5.128 0-9.3 4.172-9.3 9.3s4.172 9.3 9.3 9.3 9.3-4.172 9.3-9.3-4.172-9.3-9.3-9.3M13.833 5l-1.917 7.3H16V14h-3.692a2 2 0 0 1-1.932-2.519L12.072 5z"
  })));
};
export default SvgIconClockStroke;